



































































import BaseComponent from '@/components/base-component.vue';
import ClinicStateForm from '@/components/clinic-states/clinic-state-form.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { EstadoClinicoDTO, EstadoClinicoFiltroDTO } from '@/interfaces/clinic-states';
import * as service from '@/services/clinic-states';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { PaginationSyncDTO, ResultPagDTO } from '../../../interfaces/base-dto';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    ClinicStateForm,
  },
})
export default class ClinicStates extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public id: Number = null;
  private filtros: EstadoClinicoFiltroDTO = new EstadoClinicoFiltroDTO();
  private items: EstadoClinicoDTO[] = [];

  public headers: any = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<EstadoClinicoDTO> = new ResultPagDTO<EstadoClinicoDTO>();

  private mounted(): void {
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.pesquisar();
  }

  private pesquisar() {
    this.loading = true;
    this.error = false;
    this.filtros.page = this.pagination.page;
    this.filtros.size = this.pagination.rowsPerPage;
    this.addSubsc(
      service.getClinicStatesByFilter(this.filtros).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
